(function(){
  const STEP = 0.125;
  const clamp8 = v => Math.round(v/STEP)*STEP;

  function parseSize(str){
    if(!str) return NaN;
    str = (""+str).trim().toLowerCase().replace(/″|”/g,'"');
    const frac = /^(\d+)?[ -]?(\d+)\/(\d+)$/;
    const m = str.match(frac);
    if(m){
      const whole = m[1] ? parseInt(m[1],10) : 0;
      const num   = parseInt(m[2],10);
      const den   = parseInt(m[3],10) || 1;
      return whole + (num/den);
    }
    const n = Number(str.replace(/[^0-9.]/g,''));
    return isNaN(n) ? NaN : n;
  }

  function fmtDec(n){ return clamp8(n).toFixed(3).replace(/\.?0+$/,''); }

  function bump(input, dir){
    const v = parseSize(input.value);
    const next = isNaN(v) ? STEP : (v + dir*STEP);
    input.value = fmtDec(next);
  }

  function attachSpinners(form){
    if(!form) return;
    form.querySelectorAll('.akf-spin').forEach(box=>{
      const input = box.querySelector('input');
      box.querySelectorAll('button').forEach(btn=>{
        btn.addEventListener('click', ()=>bump(input, Number(btn.dataset.dir)));
      });
    });
  }

  function buildUrl(category, w, l, d, extra){
    if(w < l){ const t=w; w=l; l=t; }
    const size = `${fmtDec(w)}x${fmtDec(l)}x${fmtDec(d)}`;
    const base = `${location.protocol}//${location.host}`;
    let url = `${base}/build/${encodeURIComponent(category)}/${encodeURIComponent(size)}`;
    if(extra){ url += `?${extra}`; }
    return url;
  }

  function goTo(url){ console.log('[AKF] navigating to', url); window.location.href = url; }

  // Called by form onsubmit
  window.AKF_buildPleated = function(ev){
    ev.preventDefault();
    const w = parseSize(document.getElementById('akf-width')?.value);
    const l = parseSize(document.getElementById('akf-length')?.value);
    const d = parseSize(document.getElementById('akf-depth')?.value);
    const q = document.getElementById('akf-quality')?.value;
    if([w,l,d].some(isNaN)){
      alert('Please enter valid Width, Length, and Depth. Fractions allowed.');
      return false;
    }
    goTo(buildUrl('merv', w, l, d, `quality=${encodeURIComponent(q)}`));
    return false;
  };

  // Enhance +/- buttons when the page loads
  document.addEventListener('DOMContentLoaded', ()=>{
    attachSpinners(document.getElementById('akf-form-pleated'));
  });
})();
